export function isParticipantID(data) {
    return typeof data === 'string' && data.length > 0;
}
export function isEvent(data) {
    return Boolean(data && typeof data === 'object' && 'chanId' in data && 'event' in data);
}
export function isRPCCall(data) {
    if (data && typeof data === 'object' && 'chanId' in data && 'rpc' in data) {
        return true;
    }
    return false;
}
export function isRPCReply(data) {
    if (data &&
        typeof data === 'object' &&
        'chanId' in data &&
        'replyTo' in data &&
        !('error' in data)) {
        return true;
    }
    return false;
}
export function isRPCErrorReply(data) {
    if (data &&
        typeof data === 'object' &&
        'chanId' in data &&
        'replyTo' in data &&
        'error' in data) {
        return true;
    }
    return false;
}
export function isRPCCallType(type, data) {
    if (typeof data !== 'object' || !data) {
        return false;
    }
    return (data.rpc === type && typeof data.id === 'string' && 'payload' in data);
}
export const isFormSelectElement = (element) => element.type === 'select';
export const isFormChecklistElement = (element) => element.type === 'checklist';
export const isFormInputElement = (element) => ['number', 'text', 'password', 'email', 'tel', 'url', 'textarea'].includes(element.type);
export const isFormRadioGroupElement = (element) => element.type === 'radio';
export const isFormRangeElement = (element) => element.type === 'range';
//# sourceMappingURL=typeGuards.js.map